<template>
  <div class="four">
    <!--        <i class="iconfont icon-sousuo"></i>-->
    <span>
      <a href="https://www.facebook.com/VivancoGlobalSolutions/" target="_blank">
        <i class="iconfont icon-Ankerwebicon-"></i>
      </a>
    </span>
    <span>
      <a href="https://www.linkedin.com/company/vivanco-global-solutions/" target="_blank">
        <i class="iconfont icon-ins"></i>
      </a>
    </span>
    <span>
      <a href="https://www.youtube.com/channel/UCDtTBo1CjkN8rjuV15buMoA?view_as=subscriber" target="_blank">
         <i class="iconfont icon-youtobe"></i>
      </a>
    </span>
  </div>
</template>

<script>
export default {
  name: "four"
};
</script>

<style scoped>
.four {
  position: absolute;
  top: 20vh;
  width: 30px;
  right: 9.5%;
  z-index: 10000;
  display: flex;
  flex-direction: column;
}
.four span {
  margin-top: 30px;
  display: inline-block;
  height: 40px;
  width: 40px;
  background-color: black;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
}
.four span i {
  font-size: 25px;
  color: white;
  cursor: pointer;
  transition: all 600ms;
}
.four span i:hover {
  color: #91c131;
}
</style>
